// TODO - Das hier muss ganz dringend besser gelöst werden!!!

import { LorenzFormElement } from '@lib/forms';

export const _resetForcedValuePatching = (self: LorenzFormElement): void => {
	setTimeout(() => {
		self.forcedValuePatching = false;
		self.updateValueAndValidity();
	}, 2345);
};
